import { CommonGet, CommonPost } from '../../helpers/HttpClient';
import tokenDecoder from '../../utils/tokenDecoder';

export default {
  getfactoriesForDropDown,
  getGroupsForDropdown,
  getFactoriesByGroupID,
  getAllFactories,
  getAccountTypeNamesForDropdown,
  getReferenceNumber,
  saveGeneralJournal,
  getTransactionTypeList,
  getGeneralJournalDetailsByReferenceNumber,
  updateGeneralJournal,
  approveGeneralJournal,
  getLedgerAccountNamesForDropdown,
  getVoucherTypeList,
  getLedgerAccountNamesForDatagrid,
  getFinancialYearStartDateByGroupIDFactoryID,
  getChequeNumber,
  ReJectLedgerTransaction,
  getTranLedgerListForDropdown,
  getSuppliersForDropDown,
  getPayVoucherCode,
  getLedgerAccountTRCode,
  getTranLedgerListForAutoDropdown,
  getSuppliersForDropDownAuto,
  getAccountDescriptions,
  GetBankBranchCode,
  getChequeNumberAvailable,
  GetAllPayableModes,
  GetInvoicePaymentDetails


};

async function getAccountDescriptions(accountID) {
  const response = await CommonGet('/api/AccountType/GetAccountDescriptions', "accountID=" + parseInt(accountID));
  return response.data;
}

async function getAllFactories() {
  var factoryArray = [];
  const response = await CommonGet('/api/Factory/GetAllFactories', null);
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
}

async function getFactoriesByGroupID(groupID) {
  var factoryArray = [];
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
}

async function getfactoriesForDropDown(groupID) {
  var factoryArray = [];

  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + groupID)
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function getGroupsForDropdown() {
  var groupArray = [];
  const response = await CommonGet('/api/Group/GetAllGroups', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
  }
  return groupArray;
}

async function getAccountTypeNamesForDropdown(groupID, factoryID) {
  const response = await CommonGet('/api/AccountType/GetAccountTypeNamesForDropdown',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));

  let array = ["Select Account "]
  for (let item of Object.entries(response.data)) {
    array[item[1]["accountTypeID"]] = item[1]["accountTypeName"]
  }
  return array;
}

async function getReferenceNumber(model) {
  const response = await CommonGet('/api/AuditTrialReport/GetModifiedVoucherCodeV1', 'groupID=' + model.groupID + '&factoryID='
    + model.factoryID + '&voucherYear=' + model.date + '&voucherCode=' + model.voucherCode + '&ledgerAccountTRCode=' + model.ledgerAccountTRCode);
  return response;
}

async function GetBankBranchCode(model) {
  const response = await CommonGet('/api/LedgerAccount/GetBankBranchCode', 'groupID=' + model.groupID + '&factoryID='
    + model.factoryID + '&ledgerAccountID=' + model.ledgerAccountID);
  return response;
}

async function getChequeNumberAvailable(factoryID, bankCode, branchCode, modeoftransactionNumber) {
  const response = await CommonGet('/api/LedgerAccount/GetChequeNumberAvailable', "factoryID=" + parseInt(factoryID) + "&bankCode=" + bankCode + "&branchCode=" + branchCode + "&chequeNumber=" + parseInt(modeoftransactionNumber));
  return response;
}

async function saveGeneralJournal(generalJournalDetails) {
  let saveModel = {
    ledgerTransactionID: 0,
    groupID: parseInt(generalJournalDetails.groupID.toString()),
    factoryID: parseInt(generalJournalDetails.factoryID.toString()),
    transactionTypeID: parseInt(generalJournalDetails.transactionTypeID),
    referenceNumber: generalJournalDetails.referenceNumber.toString(),
    referenceNumberInter: "",
    chequeNumber: generalJournalDetails.chequeNumber,
    voucherType: parseInt(generalJournalDetails.voucherType),
    transactionMode: parseInt(generalJournalDetails.transactionMode),
    voucherCode: generalJournalDetails.referenceNumber.substring(0, 2),
    recipientName: generalJournalDetails.recipientName,
    isActive: true,
    journalData: generalJournalDetails.journalData,
    date: generalJournalDetails.date,
    dueDate: generalJournalDetails.dueDate,
    createdBy: tokenDecoder.getUserIDFromToken(),
    preparedBy: tokenDecoder.getUserIDFromToken(),
    interEstateID: parseInt(generalJournalDetails.interEstateID.toString()),
    createdDate: new Date().toISOString(),
    isInterEstate: generalJournalDetails.isInterEstate,
    status: parseInt(generalJournalDetails.status.toString()),
    reconsilationStatus: parseInt(generalJournalDetails.reconsilationStatus.toString()),
    supplierID: parseInt(generalJournalDetails.supplierID.toString()),
    tranLedgerAccountID: parseInt(generalJournalDetails.tranLedgerAccountID),
    modeoftransactionID: parseInt(generalJournalDetails.modeoftransaction),
    modeoftransactionNumber: generalJournalDetails.modeoftransactionNumber,
    payee: generalJournalDetails.payee,
  };
  const response = await CommonPost('/api/InvoicPayment/SaveInvoicePayment', null, saveModel);
  return response;
}

async function GetInvoicePaymentDetails(groupID, factoryID, supplierID, payableModeID, transactionTypeID, fromDate, toDate) {
  var newModel = {
    groupID: parseInt(groupID),
    factoryID: parseInt(factoryID),
    supplierID: parseInt(supplierID) == 0 ? null : parseInt(supplierID),
    payableModeID: parseInt(payableModeID),
    transactionTypeID: parseInt(transactionTypeID) == 0 ? null : parseInt(transactionTypeID),
    fromDate: fromDate == null ? fromDate : fromDate,
    toDate: toDate == null ? toDate : toDate,
  }
  const response = await CommonPost('/api/InvoicPayment/GetInvoicePaymentDetails', null, newModel);
  return response.data;
}

async function getSuppliersForDropDown(groupID,factoryID) {
  const response = await CommonGet('/api/InvoicPayment/GetInvoicePaymentDetailsFactoryID',"groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  let supplierArray = [];
  for (let item of Object.entries(response.data)) {
    supplierArray[item[1]["supplierID"]] =item[1]["supplierName"]
  }
  return supplierArray;
}

async function getSuppliersForDropDownAuto(factoryID, groupID) {
  const response = await CommonGet('/api/InvoicPayment/GetInvoicePaymentDetailsFactoryID', "factoryID=" + parseInt(factoryID) + "&groupID=" + parseInt(groupID));
  return response.data;
}

async function GetAllPayableModes() {
  var paybleModeArray = [];
  const response = await CommonGet('/api/InvoicPayment/GetAllPayableModes', null);
  for (let item of Object.entries(response.data)) {
    paybleModeArray[item[1]["payableModeID"]] = item[1]["payableModeName"];
  }
  return paybleModeArray;
}

async function getTransactionTypeList() {
  const response = await CommonGet('/api/ManualUploadTransaction/GetTransactionTypes', null)
  return response.data;
}

async function getGeneralJournalDetailsByReferenceNumber(referenceNumber, groupID, factoryID) {
  const response = await CommonGet('/api/GeneralJournal/GetGeneralJournalDetailsByReferenceNumber', "referenceNumber=" + referenceNumber.toString() +
    "&groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  return response.data;
}

async function updateGeneralJournal(generalJournal) {
  let updateModel = {
    ledgerTransactionID: parseInt(generalJournal.ledgerTransactionID),
    groupID: generalJournal.groupID,
    factoryID: generalJournal.factoryID,
    transactionTypeID: parseInt(generalJournal.transactionTypeID),
    tranLedgerAccountID: parseInt(generalJournal.tranLedgerAccountID),
    referenceNumber: (generalJournal.referenceNumber.toString()),
    voucherType: parseInt(generalJournal.voucherType),
    transactionMode: parseInt(generalJournal.transactionMode),
    recipientName: generalJournal.recipientName,
    chequeNumber: generalJournal.chequeNumber,
    isActive: true,
    journalData: generalJournal.journalData,
    date: generalJournal.date,
    dueDate: generalJournal.dueDate,
    updatedBy: tokenDecoder.getUserIDFromToken(),
    modifiedBy: tokenDecoder.getUserIDFromToken(),
    modifiedDate: new Date().toISOString(),
    voucherCode: generalJournal.voucherCode
  }
  const response = await CommonPost('/api/GeneralJournal/UpdateGeneralJournal', null, updateModel); return response;
}

async function approveGeneralJournal(generalJournal) {
  let updateModel = {
    ledgerTransactionID: 0,
    groupID: parseInt(generalJournal.groupID.toString()),
    factoryID: parseInt(generalJournal.factoryID.toString()),
    transactionTypeID: parseInt(generalJournal.transactionTypeID),
    referenceNumber: (generalJournal.referenceNumber.toString()),
    referenceNumberInter: (generalJournal.referenceNumberInter),
    chequeNumber: generalJournal.chequeNumber,
    voucherType: parseInt(generalJournal.voucherType),
    transactionMode: parseInt(generalJournal.transactionMode),
    voucherCode: generalJournal.voucherCode,
    recipientName: generalJournal.recipientName,
    isActive: true,
    journalData: generalJournal.journalData,
    date: generalJournal.date,
    dueDate: generalJournal.dueDate,
    createdBy: tokenDecoder.getUserIDFromToken(),
    preparedBy: tokenDecoder.getUserIDFromToken(),
    interEstateID: parseInt(generalJournal.interEstateID.toString()),
    createdDate: new Date().toISOString(),
    isInterEstate: generalJournal.isInterEstate,
    isMain: generalJournal.isMain
  }
  const response = await CommonPost('/api/GeneralJournal/ApproveGeneralJournal', null, updateModel);
  return response;
}

async function getLedgerAccountNamesForDropdown(groupID, factoryID) {
  const response = await CommonGet('/api/LedgerAccount/GetLedgerAccountNamesForDropdown',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));

  let array = ["Select Account "]
  for (let item of Object.entries(response.data)) {
    array[item[1]["ledgerAccountID"]] = item[1]["ledgerAccountName"]
  }
  return array;
}

async function getVoucherTypeList() {
  const response = await CommonGet('/api/VoucherType/GetAllVoucherTypes', null)
  return response.data;
}

async function getLedgerAccountNamesForDatagrid(groupID, factoryID) {
  const response = await CommonGet('/api/LedgerAccount/GetLedgerAccountNamesForDropdown',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));

  let data = response.data;
  let result = data.map((u) => ({ ledgerAccountName: u.ledgerAccountName, ledgerAccountID: u.ledgerAccountID }));
  return result;
}

async function getFinancialYearStartDateByGroupIDFactoryID(groupID, factoryID) {
  const response = await CommonGet('/api/GeneralJournal/GetFinancialYearStartDateByGroupIDFactoryID',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  return response.data;
}

async function getChequeNumber(ledgerAccountID) {
  const response = await CommonGet('/api/ChequeNumberSequence/GetChequeNumberByLedgerAccountID', "ledgerAccountID=" + parseInt(ledgerAccountID));
  return response;
}

async function ReJectLedgerTransaction(requestModel) {

  let rejectModel = {
    groupID: parseInt(requestModel.groupID.toString()),
    factoryID: parseInt(requestModel.factoryID.toString()),
    referenceNumber: requestModel.referenceNumber.toString(),
    rejectRemark: requestModel.rejectRemark.toString(),
    modifiedBy: tokenDecoder.getUserIDFromToken()
  }
  const response = await CommonPost('/api/GeneralJournal/RejectGeneralJournalTransactionByReferenceNumber', null, rejectModel);
  return response;
}

async function getLedgerAccountTRCode(factoryID) {
  const response = await CommonGet('/api/GeneralJournal/GetTranLedgerListForDropdown', "factoryID=" + parseInt(factoryID));
  return response.data;
}

async function getTranLedgerListForDropdown(factoryID, modeOfTransaction = 0) {
  var ledgerArray = [];
  const response = await CommonGet(
    '/api/GeneralJournal/GetTranLedgerListForDropdown',
    "factoryID=" + parseInt(factoryID) + "&modeOfTransaction=" + parseInt(modeOfTransaction)
  );

  for (let item of Object.entries(response.data)) {
    ledgerArray[item[1]["ledgerAccountID"]] = item[1]["ledgerAccountName"];
  }
  return ledgerArray;
}

async function getTranLedgerListForAutoDropdown(factoryID, modeOfTransaction = 0) {
  const response = await CommonGet(
    '/api/GeneralJournal/GetTranLedgerListForDropdown',
    "factoryID=" + parseInt(factoryID) + "&modeOfTransaction=" + parseInt(modeOfTransaction)
  );
  return response.data;
}

async function getPayVoucherCode() {
  const response = await CommonGet('/api/VoucherType/GetInvoicePayVoucherCode', null)
  return response.data;
}
